if (!customElements.get('parana-hero')) {
  customElements.define('parana-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.index = 0;
      this.mobile = matchMedia('(max-width:749px)');
      this.progressButtons = [...this.querySelectorAll('[data-hero-target]')];
      this.userPaused = false;
      this.explicitPlay = false;
      this.visible = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.playButton = this.querySelector('[data-video-toggle]');
      const syncButton = () => {
        const video = this.slides[this.index]?.querySelector('video');
        const playing = video ? !video.paused : !this.userPaused;
        this.playButton.hidden = !video && !this.mobile.matches;
        this.playButton.setAttribute('aria-pressed', String(playing));
        this.playButton.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      };
      this.sync = () => {
        const video = this.slides[this.index]?.querySelector('video');
        this.slides.forEach((slide, i) => { if (i !== this.index) slide.querySelector('video')?.pause(); });
        const allowed = this.explicitPlay || (this.dataset.autoplay === 'true' && !navigator.connection?.saveData);
        if (video && this.visible && !document.hidden && !this.userPaused && allowed) {
          if (video.dataset.src) { video.src = video.dataset.src; delete video.dataset.src; }
          video.play().catch(() => syncButton());
        } else video?.pause();
        syncButton();
      };
      this.show = (index) => {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.imageElapsed = 0;
        const currentVideo = this.slides[this.index].querySelector('video');
        if (currentVideo) currentVideo.currentTime = 0;
        this.progressButtons.forEach((button,i) => { button.setAttribute('aria-current',String(i === this.index)); button.style.setProperty('--progress', '0%'); });
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        const next = this.slides[(this.index + 1) % this.slides.length];
        const thumbnail = this.querySelector('[data-next-image]');
        if (thumbnail && next.dataset.thumbnail) thumbnail.src = next.dataset.thumbnail;
        this.querySelector('[data-hero-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
        this.sync();
      };
      this.querySelectorAll('video').forEach(video => {
        video.loop = !this.mobile.matches;
        on(video, 'timeupdate', () => { if (Number.isFinite(video.duration) && video.duration > 0 && video === this.slides[this.index].querySelector('video')) this.progressButtons[this.index]?.style.setProperty('--progress', (video.currentTime / video.duration * 100) + '%'); });
        on(video, 'ended', () => { if (this.mobile.matches && this.visible && !this.userPaused) this.show(this.index + 1); });
        on(video, 'playing', () => { video.classList.add('is-playing'); syncButton(); });
        on(video, 'pause', syncButton);
        on(video, 'error', () => { video.classList.remove('is-playing'); syncButton(); });
      });
      on(this.playButton, 'click', () => {
        const video = this.slides[this.index]?.querySelector('video');
        this.userPaused = video ? !video.paused : !this.userPaused;
        this.explicitPlay = !this.userPaused;
        this.sync();
      });
      on(this, 'click', event => {
        const target = event.target.closest('[data-hero-target]');
        if (target) this.show(Number(target.dataset.heroTarget));
        if (event.target.closest('[data-next]')) this.show(this.index + 1);
        if (event.target.closest('[data-prev]')) this.show(this.index - 1);
      });
      on(this.mobile, 'change', () => { this.querySelectorAll('video').forEach(video => video.loop = !this.mobile.matches); this.sync(); });
      on(document, 'visibilitychange', this.sync);
      on(this.reduced, 'change', () => { this.explicitPlay = false; this.sync(); });
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
      });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .1 });
      this.observer.observe(this);
      this.show(0);
      this.imageTimer = setInterval(() => {
        if (!this.mobile.matches || !this.visible || document.hidden || this.userPaused || this.slides[this.index]?.querySelector('video')) return;
        if (!this.explicitPlay && (this.dataset.autoplay !== 'true' || navigator.connection?.saveData)) return;
        this.imageElapsed += 100;
        this.progressButtons[this.index]?.style.setProperty('--progress', Math.min(100,this.imageElapsed / 80) + '%');
        if (this.imageElapsed >= 8000) this.show(this.index + 1);
      }, 100);
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.imageTimer);
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
